export default "__VITE_ASSET__cf825101__"